<div class="ibox detailed-view-ibox" *ngIf="incidentReportsService.showDetailedView && incidentReportsService.selectedItemData">
    <div class="detailed-view-header">
        <div class="detailed-view-amenity-name">
            Report ID: {{incidentReportsService.selectedItemData.incidentReportNumber}}
        </div>
        <span class="close-detailed-view" (click)="incidentReportsService.toggleDetailedView(null)">×</span>
    </div>
    <div class="detailed-view-body">
        <div class="detailed-view__more-info m-t-md">
            <form #form="ngForm" *ngIf="incidentReportsService.selectedItemData"
                  [ngClass]="{'ng-submitted': form.submitted}"
                  autocomplete="off">
                <div class="detailed-view-navigation">
                    <div class="col-md-4 col-sm-4 col-xs-4 no-padding">
                        <div class="button-section" (click)="navPosition = 'info';"
                             [ngClass]="{'active': navPosition == 'info'}">
                            Info
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-4 no-padding">
                        <div class="button-section" (click)="navPosition = 'comments';"
                             [ngClass]="{'active': navPosition == 'comments'}">
                            Comments
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-4 no-padding">
                        <div class="button-section" (click)="navPosition = 'history';"
                             [ngClass]="{'active': navPosition == 'history'}">
                            History
                        </div>
                    </div>
                </div>
                <div class="tab-content" *ngIf="navPosition == 'info'">
                    <div class="row m-b-xs" (dblclick)="setEditModeFor(incidentReportsService.selectedItemData, 'incident', true)">
                        <div class="dv-label col-md-4">
                            <label>Incident</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!incidentReportsService.selectedItemData.formFields.incident.editMode">
                            <pre>{{incidentReportsService.selectedItemData.incident || '-'}}</pre>
                            <i *ngIf="incidentReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(incidentReportsService.selectedItemData, 'incident', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="incidentReportsService.selectedItemData.formFields.incident.editMode">
                            <textarea class="form-control" name="incident" [ngModel]="incidentReportsService.selectedItemData.incident" required
                                      (keyup.enter)="applyChanges(incidentReportsService.selectedItemData, form,  {incident: form.value.incident})"></textarea>
                            <button type="button" (click)="applyChanges(incidentReportsService.selectedItemData, form, {incident: form.value.incident})">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(incidentReportsService.selectedItemData, 'incident', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="setEditModeFor(incidentReportsService.selectedItemData, 'type', true)">
                        <div class="dv-label col-md-4">
                            <label>Type</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!incidentReportsService.selectedItemData.formFields.type.editMode">
                            <span>{{(incidentReportsService.selectedItemData.incidentReportType ? incidentReportsService.selectedItemData.incidentReportType.name : incidentReportsService.selectedItemData.incidentReportTypeOther) || '-'}}</span>
                            <i *ngIf="incidentReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(incidentReportsService.selectedItemData, 'type', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="incidentReportsService.selectedItemData.formFields.type.editMode">
                            <search-select [ngModel]="!incidentReportsService.selectedItemData.incidentReportTypeOther ? incidentReportsService.selectedItemData.incidentReportType.id : '0'"
                                           name="type" required #incidentTypeSelect
                                           [data]="typeSelect(incidentReportsService.incidentTypes)"></search-select>

                            <input *ngIf="incidentTypeSelect.value == '0'" class="form-control"
                                   [ngModel]="incidentReportsService.selectedItemData.incidentReportTypeOther" name="incidentReportTypeOther"
                                   placeholder="Other Type" maxlength="255">

                            <button type="button"
                                    (click)="applyChanges(incidentReportsService.selectedItemData, form, form.value.type != '0' ? {incidentReportType: form.value.type} : {incidentReportTypeOther: form.value.incidentReportTypeOther})">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(incidentReportsService.selectedItemData, 'type', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs"
                         [hidden]="incidentReportsService.buildings.length < 2"
                         (dblclick)="setEditModeFor(incidentReportsService.selectedItemData, 'building', true, form)">
                        <div class="dv-label col-md-4">
                            <label>Building</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!incidentReportsService.selectedItemData.formFields.building.editMode">
                            <span>{{incidentReportsService.selectedItemData.buildingName || '-'}}</span>
                            <i *ngIf="incidentReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(incidentReportsService.selectedItemData, 'building', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="incidentReportsService.selectedItemData.formFields.building.editMode">
                            <select class="form-control"
                                    name="building"
                                    [disabled]="buildingSelectIsDisabled"
                                    (change)="changeBuilding($event.target.value, form)"
                                    [ngModel]="incidentReportsService.selectedItemData.buildingId">
                                <option value=""></option>
                                <option *ngFor="let building of incidentReportsService.buildings" [value]="building.id">
                                    {{building.name}}
                                </option>
                            </select>
                            <button type="button" (click)="applyChanges(incidentReportsService.selectedItemData, form, {building: form.value.building}, 'building')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(incidentReportsService.selectedItemData, 'building', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="setEditModeFor(incidentReportsService.selectedItemData, 'unit', true, form)">
                        <div class="dv-label col-md-4">
                            <label>Unit</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!incidentReportsService.selectedItemData.formFields.unit.editMode">
                            <span>{{incidentReportsService.selectedItemData.suiteNumber || '-'}}</span>
                            <i *ngIf="incidentReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(incidentReportsService.selectedItemData, 'unit', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="incidentReportsService.selectedItemData.formFields.unit.editMode">
                            <search-select [ngModel]="incidentReportsService.selectedItemData.suiteId"
                                           name="unit" required style="height: 26px;"
                                           (ngModelChange)="changeUnit($event, form)"
                                           [data]="suiteToSearchSelect(suites)"></search-select>
                            <input *ngIf="form.value.unit === 0" class="form-control"
                                   [ngModel]="incidentReportsService.selectedItemData.suiteNumber"
                                   name="otherSuite"
                                   placeholder="Other Unit Number" maxlength="255" required>
                            <spinner [spinnerShow]="form.value.building && !suites.length"></spinner>
                            <button type="button" (click)="applyChanges(incidentReportsService.selectedItemData, form, {suite: form.value.unit}, 'unit')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(incidentReportsService.selectedItemData, 'unit', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs"
                         (dblclick)="setEditModeFor(incidentReportsService.selectedItemData, 'resident', true, form)">
                        <div class="dv-label col-md-4">
                            <label>Resident</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!incidentReportsService.selectedItemData.formFields.resident.editMode">
                            <span>{{incidentReportsService.selectedItemData.residentFullName || '-'}}</span>
                            <i *ngIf="incidentReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(incidentReportsService.selectedItemData, 'resident', true, form)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="incidentReportsService.selectedItemData.formFields.resident.editMode">
                            <select class="form-control"
                                    [ngModel]="incidentReportsService.selectedItemData.residentId"
                                    name="resident" required #residentSelect
                                    [disabled]="!residents.length">
                                <option value="" hidden></option>
                                <option *ngFor="let resident of residents" [value]="resident.id">{{resident.fullName}}</option>
                            </select>
                            <input *ngIf="residentSelect.value === '0'" class="form-control"
                                   placeholder="Other Resident Name"
                                   [ngModel]="incidentReportsService.selectedItemData.residentFullName"
                                   name="otherResident" maxlength="255" required>
                            <spinner [spinnerShow]="form.value.unit && !residents.length"></spinner>
                            <button type="button" (click)="applyChanges(incidentReportsService.selectedItemData, form, {resident: form.value.resident}, 'resident')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(incidentReportsService.selectedItemData, 'resident', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="setEditModeFor(incidentReportsService.selectedItemData, 'reportedArea', true)">
                        <div class="dv-label col-md-4">
                            <label>Report Area</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!incidentReportsService.selectedItemData.formFields.reportedArea.editMode">
                            <span>{{incidentReportsService.selectedItemData.reportedArea || '-'}}</span>
                            <i *ngIf="incidentReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(incidentReportsService.selectedItemData, 'reportedArea', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="incidentReportsService.selectedItemData.formFields.reportedArea.editMode">
                            <input class="form-control" name="reportedArea" [ngModel]="incidentReportsService.selectedItemData.reportedArea" required
                                   maxlength="255" (keyup.enter)="applyChanges(incidentReportsService.selectedItemData, form,  {reportedArea: form.value.reportedArea})">
                            <button type="button" (click)="applyChanges(incidentReportsService.selectedItemData, form, {reportedArea: form.value.reportedArea})">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(incidentReportsService.selectedItemData, 'reportedArea', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs" (dblclick)="setEditModeFor(incidentReportsService.selectedItemData, 'reportedBy', true)">
                        <div class="dv-label col-md-4">
                            <label>Reported By</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!incidentReportsService.selectedItemData.formFields.reportedBy.editMode">
                            <span>{{incidentReportsService.selectedItemData.reportedBy || '-'}}</span>
                            <i *ngIf="incidentReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(incidentReportsService.selectedItemData, 'reportedBy', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8" *ngIf="incidentReportsService.selectedItemData.formFields.reportedBy.editMode">
                            <input class="form-control" name="reportedBy" [ngModel]="incidentReportsService.selectedItemData.reportedBy" required
                                   maxlength="255" (keyup.enter)="applyChanges(incidentReportsService.selectedItemData, form, {reportedBy: form.value.reportedBy})">
                            <button type="button" (click)="applyChanges(incidentReportsService.selectedItemData, form, {reportedBy: form.value.reportedBy})">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button" (click)="setEditModeFor(incidentReportsService.selectedItemData, 'reportedBy', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs datepicker-wrapper"
                         (dblclick)="setEditModeFor(incidentReportsService.selectedItemData, 'incidentAt', true)">
                        <div class="dv-label col-md-4">
                            <label>Happened At</label>
                        </div>
                        <div class="dv-value col-md-8" *ngIf="!incidentReportsService.selectedItemData.formFields.incidentAt.editMode">
                            <span>{{incidentReportsService.selectedItemData.incidentAt ? (incidentReportsService.selectedItemData.incidentAt | mccDate:true: true) : '-'}}</span>
                            <i *ngIf="incidentReportsService.selectedItemData.isCanEdit" class="fa fa-pencil pull-right"
                               (click)="setEditModeFor(incidentReportsService.selectedItemData, 'incidentAt', true)"
                               data-toggle="tooltip" data-placement="top" title="Edit"></i>
                        </div>
                        <div class="dv-value-edit col-md-8 inlineDateAndTime directory-add-modal-date-field"
                             *ngIf="incidentReportsService.selectedItemData.formFields.incidentAt.editMode">
                            <mat-form-field>
                                <input matInput [(ngModel)]="incidentReportsService.selectedItemData.incidentAt"
                                       (focus)="dateFromPicker.open()" (click)="dateFromPicker.open()" [max]="maxDate"
                                       name="incidentAt" [matDatepicker]="dateFromPicker" placeholder="Choose a date" required>
                                <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
                                <mat-datepicker #dateFromPicker></mat-datepicker>
                            </mat-form-field>
                            <div class="input-group bootstrap-timepicker timepicker" (click)="openTimepicker()">
                                <input id="timepicker" class="form-control input-small" name="startTime"
                                       [ngModel]="getTime(incidentReportsService.selectedItemData.incidentAt)" required>
                                <span class="input-group-addon"><i class="glyphicon glyphicon-time"></i></span>
                            </div>
                        </div>
                        <div class="dv-value-edit m-t-xs pull-right"
                             style="padding: 0 15px;"
                             *ngIf="incidentReportsService.selectedItemData.formFields.incidentAt.editMode">
                            <button type="button"
                                    style="border-left: 1px solid #dedfe0;"
                                    (click)="applyChanges(incidentReportsService.selectedItemData, form, {incidentAt: form.value.incidentAt}, 'incidentAt')">
                                <i class="fa fa-check"></i>
                            </button>
                            <button type="button"
                                    (click)="setEditModeFor(incidentReportsService.selectedItemData, 'incidentAt', false)">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div class="row m-b-xs">
                        <div class="dv-label col-md-4">
                            <label>Created On</label>
                        </div>
                        <div class="dv-value col-md-8">
                            {{incidentReportsService.selectedItemData.createdAt ? (incidentReportsService.selectedItemData.createdAt | mccDate:true: true) : '-'}}
                        </div>
                    </div>
                    <hr>
                    <!-- ___ Images  ___ -->
                    <div class="row m-b-sm" *ngIf="incidentReportsService.selectedItemData.isCanEdit">
                        <div class="dv-label col-md-4">
                            <label>Attachments</label>
                        </div>
                        <div class="dv-label col-md-8 text-right">
                            <input type="file"
                                   name="attachment"
                                   id="add-attachment-btn"
                                   (change)="addFile($event)"
                                   [disabled]="disabledFileInput"
                                   hidden>
                            <label for="add-attachment-btn" class="btn mtv-primary-color"><strong>Add Attachment</strong></label>
                        </div>
                    </div>
                    <ul class="attachment-box">
                        <li *ngFor="let item of incidentReportsService.selectedItemData.attachments; let i = index" class="attachment">
                            <div class="image-container mtv-primary-color">
                                <div *ngIf="!incidentReportsService.fileIsImage(item)" class="file-icon" (click)="incidentReportsService.showAttachment(item)">
                                    <i class="fa fa-file-o" [ngClass]="'fa-file-' + incidentReportsService.getFileExt(item.link) + '-o'" aria-hidden="true"></i>
                                </div>
                                <div *ngIf="incidentReportsService.fileIsImage(item)" class="image-wrapper" (click)="incidentReportsService.showAttachment(item)">
                                    <img class="image-attached"
                                         [src]="item.link">
                                </div>
                                <div class="file-name">
                                    <div class="file-name-text">
                                        <a class="file-link" [href]="item.link" download title="{{item.name}}">
                                            {{item.name}}
                                        </a>
                                    </div>
                                    <i *ngIf="incidentReportsService.selectedItemData.isCanEdit"
                                       class="fa fa-trash"
                                       style="opacity: 1;"
                                       (click)="removeFile(i)"
                                       title="Delete Attachment">
                                    </i>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <spinner [spinnerShow]="disabledFileInput"></spinner>
                    <!--<div>-->
                        <!--{{incidentReportsService.selectedItemData.attachments | json}}-->
                        <!--<img class="image-attached"-->
                             <!--*ngIf="incidentReportsService.fileIsImage(incidentReportsService.selectedItemData.attachment)"-->
                             <!--(click)="incidentReportsService.showAttachment(incidentReportsService.selectedItemData.attachment)"-->
                             <!--[src]="incidentReportsService.selectedItemData.attachment.path">-->
                        <!--<div class="file-name">-->
                            <!--<div class="file-name-text">-->
                                <!--<a class="file-link" [href]="incidentReportsService.selectedItemData.attachment.path" download>-->
                                    <!--{{incidentReportsService.selectedItemData.attachment.name}}-->
                                <!--</a>-->
                            <!--</div>-->
                            <!--<i *ngIf="incidentReportsService.selectedItemData.isCanEdit"-->
                               <!--class="fa fa-trash"-->
                               <!--style="opacity: 1;"-->
                               <!--(click)="removeFile()"-->
                               <!--title="Delete Attachment">-->
                            <!--</i>-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
                <div class="tab-content" *ngIf="navPosition == 'comments'">
                    <incident-reports-comments
                        [(selectedItem)]="incidentReportsService.selectedItemData"
                        [commentsLoading]="incidentReportsService.commentsLoading"
                        [commentsListLoaded]="incidentReportsService.commentsListLoaded"
                        (updateView)="updateView($event, false)">
                    </incident-reports-comments>
                </div>
                <div class="tab-content" *ngIf="navPosition == 'history'">
                    <div class="timeline">
                        <spinner [spinnerShow]="incidentReportsService.historyLoading"></spinner>
                        <ul class="timeline__list" *ngIf="!incidentReportsService.historyLoading">
                            <li *ngFor="let a of incidentReportsService.activities">
                                <section *ngIf="a.action !== 'ignore'">
                                    <header class="timeline__header">
                                        <span>
                                            <time>{{ a.loggedAt | date:'dd.MM.yyyy hh:mm a' }}</time> by {{ a.userFullName }}
                                        </span>
                                    </header>

                                    <main class="timeline__content">
                                        <div [ngSwitch]="a.action">
                                            <ng-template [ngSwitchCase]="'update'">
                                                {{ a.activityType }}
                                                <span class="timeline__active">"{{a.name}}"</span>
                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        {{ item?.key }} :
                                                        <span class="timeline__active">"{{ item?.old }}"</span>
                                                        changed to
                                                        <span class="timeline__active">"{{ item?.new }}"</span>
                                                    </li>
                                                </ul>
                                            </ng-template>

                                            <ng-template [ngSwitchCase]="'create'">
                                                <p>
                                                    {{ a.activityType }}
                                                    <span class="timeline__active">"{{a.name}}"</span>
                                                    was received
                                                </p>

                                                <ul class="field-changes">
                                                    <li *ngFor="let item of a.data">
                                                        {{ item.key }} :
                                                        <span class="timeline__active">{{ item.value }}</span>
                                                    </li>
                                                </ul>
                                            </ng-template>
                                        </div>
                                    </main>
                                </section>
                            </li>
                        </ul>
                    </div>
                </div>

                <hr>

                <div class="btn-group dropup">
                    <a data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle">
                        Actions <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu">
                        <li *ngIf="incidentReportsService.selectedItemData.isCanEdit"
                            (click)="incidentReportsService.editIncidentReport(incidentReportsService.selectedItemData)">
                            <a>Edit</a>
                        </li>
                        <li *ngIf="incidentReportsService.selectedItemData.isCanDelete"
                            (click)="incidentReportsService.deleteIncidentReport(incidentReportsService.selectedItemData.id)">
                            <a>Delete</a>
                        </li>
                        <li (click)="incidentReportsService.getPDF(incidentReportsService.selectedItemData)">
                            <a>View PDF</a>
                        </li>
                        <li (click)="sendIncidentReport(incidentReportsService.selectedItemData)">
                            <a>Send by Email</a>
                        </li>
                    </ul>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-report-detailed-view/incident-report-detailed-view.component.html